module.exports = __webpack_public_path__ + "media/images/emblems/Cormoret-coat_of_arms-f845dfec9a7ea1dec459ea53425ad2c7.svg";